import { trackEvent } from "../../../trackEvent";

/**
 * Push content list article link clicks to datalayer when we find data-gtm-type of article_card_item
 * This assumes some basic markup like the following based on UIKit
 * 
 *  <a href="" data-gtm-type="article_card_item"></a>
 */


const test = ({ target }) => target.getAttribute("data-gtm-type") == "article_card_item" || target.closest('[data-gtm-type="article_card_item"]');

const push = ({ target, e }) => {
   const articleObjData = JSON.parse(target.querySelector(".card__articleHeading").dataset?.objData);

  trackEvent({
    "event": "click_article",
    "event_type": "click",
    ...articleObjData
  });
}

export default {
  name: "article_card_item",
  test,
  push
};